import { Grid, Paper } from "@mui/material";
import { type Evc } from "@syadem/evc-js";
import { localizedDate } from "../../../../utils/dayjs";
import { useI18n } from "../../../hooks/useI18n";
import { compactPaperSx } from "./styles";
import { SummaryField } from "./SummaryField";

export function EvcCertificateSummary({
  parsedEvc,
  evcFullName,
  vaccinationsCount,
}: {
  parsedEvc: Evc;
  evcFullName: string | null;
  vaccinationsCount: number;
}) {
  const { t, locale } = useI18n();

  return (
    <Paper sx={compactPaperSx} elevation={0}>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 4 }}>
          <SummaryField label={t("vaccines.scan_evc_preview_name")} value={evcFullName || "-"} />
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <SummaryField
            label={t("vaccines.scan_evc_preview_dob")}
            value={parsedEvc.dateOfBirth ? localizedDate(parsedEvc.dateOfBirth, locale) : "-"}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <SummaryField label={t("vaccines.scan_evc_preview_vaccinations")} value={vaccinationsCount} />
        </Grid>
      </Grid>
    </Paper>
  );
}
